import React, {Fragment} from "react";
import {useSelector} from 'react-redux'

function StepProgressBar(props) {
    const currentStep = useSelector(state => state.app.currentStep)

    return (
        <div className="progresses">
            {
                Array(props.titleArray.length).fill(1).map((el, i) => {
                    let loopStep = i + 1;
                    loopStep = currentStep === 100 ? currentStep : loopStep;
                    return <Fragment key={`progressItem-${i}`}>
                        <div className={`steps ${currentStep >= loopStep ? 'pass' : ''}`}>
                            <span className="title">{props.titleArray[i]}</span>
                            <span>
                                {
                                    currentStep > loopStep || currentStep === props.titleArray.length ?
                                        <i className="fas fa-check"/>
                                        :
                                        loopStep
                                }
                            </span>
                        </div>
                        {
                            loopStep < props.titleArray.length ?
                                <span className={`line ${currentStep > loopStep ? 'pass' : ''}`}/>
                                :
                                null
                        }
                    </Fragment>
                })
            }
        </div>
    );
}

export default StepProgressBar;